<template>
    <div id="uploadAttachmentModal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title h5" id="uploadAttachmentTitle">Select a file to attach.</div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body"> 
                    <div class="form-group">
                        <select class="custom-select" id="document_type_id" name="document_type_id" v-model="documentTypeId">
                            <option v-for="option in options" :key="'browse-attachments-' + option.id" :value="option.id" v-text="option.name"></option>
                        </select>
                    </div>
                    <div class="form-group">
                        <input type="text" class="form-control" id="browse-attachments-description" placeholder="Description" v-model="description">
                    </div>                                         
                    <form method="post" action="#" files="true" enctype="multipart/form-data" id="attachments-dropzone" class="dropzone"> 
                        <input type="hidden" name="_token" :value="csrf">             
                        <input type="hidden" name="claim_id" :value="claimId">
                    </form>
                </div>                        
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    props: {
        claimId: Number
    },
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            options: [],
            documentTypeId: null,
            description: '',
            callback: null,
            event: null,
            documentId: null
        }
    },    
    methods: {
        show: function(options, documentTypeId, callback, event, documentId = null) {       
            this.options = options;
            this.documentTypeId = documentTypeId;
            this.callback = callback;
            this.event = event;
            this.documentId = documentId;
            $('#uploadAttachmentModal').modal('show');
        }
    },
    mounted() {

        // add hide event handler
        const self = this;
        $('#uploadAttachmentModal').on('hide.bs.modal', function(e) {
            eventHub.$emit(self.event);
        }); 
    },
    created() {
        var self = this;
        eventHub.$on('show-attachment-upload', this.show);

        Dropzone.options.attachmentsDropzone = {
            url: '/ajax/claims/' + this.claimId + '/attachments',
            maxFilesize: 100, // files 100MB or less this matches php.ini
            addRemoveLinks: true,
            timeout: 15000,
            autoProcessQueue: true,
            uploadMultiple: false,
            parallelUploads: 1,
            maxFiles: 1,
            thumbnailHeight: 32,
            init: function() {
                this.on('sending', function(file, xhr, formData) {
                    formData.append('document_type_id', self.documentTypeId);
                    formData.append('description', self.description);
                    formData.append('document_id', self.documentId);
                });
                this.on('complete', function(file) {
                    this.removeAllFiles(true);
                    $('#uploadAttachmentModal').modal('hide');                                        
                });
            },
            success(files, response) {
                self.callback(response.document);
            },
            error(file, response) {
                let message = response.message ? response.message : response;
                toastr['error'](message, 'ERROR', {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
            }        
        };    
    },
    beforeDestroy() {
        eventHub.$off('show-attachment-upload');
    },    
}
</script>

<style scoped>

</style>